import { PropsWithChildren, useMemo, forwardRef } from "react";
import { Loader2 } from "lucide-react";
import classnames from "classnames";

import styles from "./button.module.css";

interface ButtonProps {
  variant?: "primary" | "ghost" | "card" | "solid" | "solid-secondary";
  /**
   * Action is in flight: prepends a spinner and blocks further clicks, so a
   * slow request cannot be submitted twice.
   */
  loading?: boolean;
}

const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>>
>(({ children, variant, className, loading = false, disabled, ...props }, ref) => {
  const variantClass = useMemo(() => {
    if (!variant) return "";

    return styles[variant];
  }, [variant]);

  return (
    <button
      ref={ref}
      className={classnames(styles.button, className, {
        [variantClass]: variant,
      })}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <Loader2 size={16} className={styles.spinner} aria-hidden />}
      {children}
    </button>
  );
});

Button.displayName = "Button";

export default Button;
